// removed by extract-text-webpack-plugin
module.exports = {"flash":"flash___2RJaM","correct":"correct___3XSdC","wrong":"wrong___3oVBS","brand":"brand___3GR-D","terciary":"terciary___3DpRD","accent":"accent___1z5ZZ","icon":"icon___3VdWX","close":"close___3RnC9","message":"message___wWBdK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flash/index.scss
// module id = 81
// module chunks = 0